/*検査6
**22ページ
*/
const answer={
    1:"B",
    2:"E",
    3:"B",
    4:"A",
    5:"C",
    6:"C",
    
    
    // 23ページ
    
    7:"A",
    8:"D",
    9:"A",
    10:"E",
    11:"D",
    12:"C",
    
    
    // 24ページ
    
    13:"E",
    14:"B",
    15:"B",
    16:"B",
    17:"E",
    18:"D",
    
    
    // 25ページ
    
    19:"D",
    20:"B",
    21:"A",
    22:"D",
    23:"C",
    24:"C",
    };

    export default answer;
